"use client";

import { CampaignMetadataHttp } from "@decibeltrade/sdk";
import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "@/contexts/dex-sdk";

export const ACTIVE_CAMPAIGNS_QUERY_KEY = "activeCampaigns";

export function activeCampaignsQueryKey() {
  return [ACTIVE_CAMPAIGNS_QUERY_KEY] as const;
}

// New launches and status flips are rare, operator-driven.
export function activeCampaignsQuery() {
  return {
    queryKey: activeCampaignsQueryKey(),
    queryFn: async () => readDexSdk.campaigns.getActive(),
    staleTime: 10 * 60_000,
  } satisfies FetchQueryOptions<CampaignMetadataHttp[]>;
}

export function useActiveCampaignsQuery() {
  return useQuery(activeCampaignsQuery());
}
